import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startCreateReturnComment = () =>
  produce((draft: Draft<State>) => {
    draft.createReturnComment.fetching = initialState.createReturnComment.fetching + 1;
  });

export const finishCreateReturnComment = () =>
  produce((draft: Draft<State>) => {
    draft.createReturnComment.fetching = initialState.createReturnComment.fetching - 1;
  });
